import { Typography } from "@packages/ds";
import styled from "styled-components";

import CPageDescription from "Components/PageDescription";
import { AddButton as _AddButton } from "ds/Button";
import { Content as DsContent } from "ds/Dialog";
import * as Table from "ds/Table";

export const Content = styled(DsContent)`
  display: block;
  width: 591px;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Details = styled(Typography.BodyText)`
  margin: 14px 0;
`;

export const Wrapper = styled.div`
  width: 100%;
`;

export const Title = styled(Typography.Title)`
  margin-bottom: 16px;
`;

export const AddButton = styled(_AddButton)`
  float: right;
`;

export const VariablesCount = styled.span`
  font-weight: 400;
  color: var(--label-granite-color, var(--granite));
`;

export const NoteWrapper = styled.span`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const TableThead = styled(Table.Thead)`
  padding-right: 24px;
  gap: 16px;
`;

export const PageDescription = styled(CPageDescription)`
  padding-top: 0;
`;

export const Code = styled(Typography.Code)`
  margin: unset;
`;
